module.exports = __webpack_public_path__ + "static/img/overseas-2.1230a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/overseas-2.png
// module id = YfKC
// module chunks = 1